<template>
  <div :class="menu.length ? 'btn-group' : ''">
    <button v-if="!primary.href" type="button" class="btn btn-primary" disabled>
      {{ primary.name }}
    </button>
    <a v-if="primary.href" :href="primary.href" class="btn btn-primary">
      {{ primary.name }}
    </a>
    <button v-if="menu.length" type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-no-icon dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <i class="fa fa-ellipsis-h"></i>
    </button>
    <div v-if="menu.length" class="dropdown-menu dropdown-menu-right">
      <a class="dropdown-item" v-for="item in menu" :key="item.href" :href="item.href">
        <i :class="'fa mr-1 ' + item.icon"></i>
        {{ item.name }}
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      primary: {
        required: true,
        type: Object
      },
      menu: {
        type: Array,
        default () {
          return []
        }
      }
    }
  }
</script>